// extracted by mini-css-extract-plugin
export default {"wrapper":"VehicleImage_wrapper__C1Wix","img":"VehicleImage_img__P47Pv","desc":"VehicleImage_desc__fcCrL","name":"VehicleImage_name__Letiz","location":"VehicleImage_location__5vKIM"};